import { StyleSheet } from "react-native-unistyles";

import CustomPlatform from "$src/core/utils/platform/platform";

/**
 * The input's focusable rectangle is the whole box, so an absolutely positioned mic
 * lands inside it and Android's FocusFinder can never reach it: FOCUS_RIGHT needs
 * `src.right < dest.right`, which is false for a contained rectangle. Lay the mic out
 * beside the input on Android TV so the two rectangles are disjoint. Touch platforms
 * hit-test rather than focus-search, and tvOS uses UIKit's own engine, so both keep
 * the overlay.
 */
const IS_ANDROID_TV = CustomPlatform.select({
  androidTV: true,
  default: false,
});

const stylesheet = StyleSheet.create(({ spacing, font, colors }) => ({
  container: {
    flex: 1,
    position: "relative",
    ...(IS_ANDROID_TV
      ? { flexDirection: "row" as const, alignItems: "center" as const }
      : null),
  },
  inputWrapper: {
    position: "relative",
    ...(IS_ANDROID_TV ? { flex: 1 } : null),
  },
  inputContentContainer: {
    fontSize: font.sizes.heading5,
  },
  inputWithVoice: {
    paddingRight: spacing(10),
  },
  listeningOverlay: {
    position: "absolute",
    left: spacing(15),
    top: 0,
    bottom: 0,
    justifyContent: "center",
    pointerEvents: "none",
  },
  inputActionPressable: {
    position: "absolute",
    right: 0,
    top: 0,
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: spacing(4),
  },
  inputActionIcon: {
    width: spacing(6),
    height: spacing(6),
    color: colors.foregroundDefault,
  },
  voiceControls: ({ withClear }: { withClear: boolean }) =>
    IS_ANDROID_TV
      ? {
          alignItems: "center" as const,
          justifyContent: "center" as const,
          paddingHorizontal: spacing(4),
        }
      : {
          position: "absolute" as const,
          right: withClear ? spacing(10) : 0,
          top: 0,
          height: "100%" as const,
          flexDirection: "row" as const,
          alignItems: "center" as const,
          paddingHorizontal: spacing(4),
        },
}));

export default stylesheet;
